module.exports = __webpack_public_path__ + "static/template-about-history-background-700829ec900b70e23c7cc2dee4cd6244.jpg";